import { Paper as MuiPaper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Paper = styled(MuiPaper)(({ theme }) => ({
  padding: theme.spacing(4),
}));
